enum Routes {
    Login = '/login',
    ForgotPassword = '/forgot-password',
    PasswordRecovery = '/password-recovery',
    ResetPassword = '/reset-password/:token',
    SignUp = '/sign-up/:token',
    Dashboard = '/dashboard',
    ApplicationsInProgress = 'applications/in-progress',
    ApplicationsCompleted = 'applications/completed',
    ApplicationDetails = '/applications/:caseId',
    UserProfile = '/user',
    UserDetails = '/user/details',
    UserSettings = '/user/settings',
    UserPrivacyPolicy = '/user/privacy-policy',
    UserUpdatePassword = '/user/update-password',
    UserTermsOfUse = '/user/terms',
    ApplicationsList = '/applications-list',
    ReferAClient = '/refer-a-client/?campId=:campaignId',
}

export default Routes;
